import type { LucideIcon } from "lucide-react";
import { Button } from "./ui/Button";

interface EmptyStateProps {
  icon: LucideIcon;
  title: string;
  description: string;
  action?: {
    label: string;
    onClick: () => void;
  };
}

/** Friendly centered empty state with a soft icon badge and optional CTA. */
export function EmptyState({
  icon: Icon,
  title,
  description,
  action,
}: EmptyStateProps) {
  return (
    <div className="text-center py-12 px-4">
      <span
        aria-hidden="true"
        className="inline-flex items-center justify-center w-16 h-16 rounded-3xl bg-accent text-accent-foreground mb-4"
      >
        <Icon className="w-8 h-8" />
      </span>
      <h3 className="text-foreground text-xl font-bold tracking-tight mb-2">{title}</h3>
      <p className="text-muted-foreground mb-6 max-w-xs mx-auto">
        {description}
      </p>
      {action && (
        <Button onClick={action.onClick} size="lg">
          {action.label}
        </Button>
      )}
    </div>
  );
}

export default EmptyState;
